module.exports = __webpack_public_path__ + "img/stick_hebergements_location_meublee.105e2344.svg";